interface ResultitemNoPricesProps {
    openEditPanelWithFocus: () => void;
}

export const NoPricesBox = ({ openEditPanelWithFocus }: ResultitemNoPricesProps) => {
    const onPickDateClick = () => {
        openEditPanelWithFocus();
    };
    return (
        <div className="result-list-item-price u-bg-marble">
            <div className="u-position-relative u-text-center u-pv8">
                <i className="icon icon--calendar u-valign-bottom" />
                <div data-testid="offer-no-price" className="u-text-center u-ph16 u-pt4 u-caption u-stone">
                    Oppgi dato
                    <br />
                    for å se priser
                </div>
                <button
                    type="button"
                    data-testid="offer-redirect-link"
                    className="button button--link link-covering-parent"
                    style={{ zIndex: 2 }}
                    onClick={onPickDateClick}>
                    <span className="u-caption u-strong">Velg dato</span>
                </button>
            </div>
        </div>
    );
};
